import axios from "axios";

interface SurveyData {
  height: number;
  weight: number;
  smoke: boolean;
  sb_pressure: number;
  db_pressure: number;
  question_0: boolean; // диабет
  question_1: boolean; // инфаркт/инсульт
  question_2: boolean; // атеросклеротические бляшки
  question_3: boolean; // ксантомы
  question_4: boolean; // липидная дуга
  question_5: boolean; // инфаркты/инсульты у родственников
  question_6: boolean; // ЛПНП у родственников
  question_7: boolean; // ксантомы у родственников
  question_8: boolean; // ЛПНП у детей
  question_9: boolean; // генодиагностика
  gender?: string; // пол пользователя
  age?: number; // возраст пользователя
  cholesterol?: number; // общий холестерин
  hdl?: number; // ЛПВП (для расчета ХС-неЛВП)
}

interface RiskResult {
  result_risk: string;
  heart_risk: string;
  hypertension_risk: string;
  lipid_risk: string;
  genetic_risk: string;
  smoke_risk: string;
}

const smokingMessages = [
  "Курение — ключевой фактор риска сердечно-сосудистых заболеваний. Чем раньше вы откажетесь от табака, тем ниже вероятность инфаркта и инсульта. Рекомендована консультация специалиста Школы отказа по курению в ФГБУ «НМИЦ ТПМ».",
  "Никотин и смолы повреждают стенки сосудов, способствуя развитию атеросклероза. Отказ от курения — лучший способ снизить этот риск. Рекомендована консультация специалиста Школы отказа по курению в ФГБУ «НМИЦ ТПМ».",
  "Курение негативно влияет на уровень кислорода в крови, заставляя сердце работать с перегрузкой. Бросив курить, вы снижаете нагрузку на сердечно-сосудистую систему. Рекомендована консультация специалиста Школы отказа по курению в ФГБУ «НМИЦ ТПМ».",
  "Даже несколько выкуренных сигарет в день увеличивают вероятность развития гипертонии и ишемической болезни сердца. Отказ от курения поможет защитить ваш организм. Рекомендована консультация специалиста Школы отказа по курению в ФГБУ «НМИЦ ТПМ».",
  "Никотин вызывает спазм сосудов, ухудшая их эластичность. После отказа от табака сосуды начинают восстанавливаться. Рекомендована консультация специалиста Школы отказа по курению в ФГБУ «НМИЦ ТПМ».",
  "У курильщиков в 2-4 раза выше риск инфаркта и инсульта по сравнению с некурящими. Чем раньше вы бросите курить, тем ниже вероятность этих опасных осложнений. Рекомендована консультация специалиста Школы отказа по курению в ФГБУ «НМИЦ ТПМ».",
  'Курение увеличивает уровень "плохого" холестерина и снижает уровень "хорошего", ускоряя развитие атеросклероза. Отказ от курения поможет нормализовать липидный обмен. Рекомендована консультация специалиста Школы отказа по курению в ФГБУ «НМИЦ ТПМ».',
  "Каждый год без курения снижает риск сердечно-сосудистых заболеваний, возвращая его к уровню некурящих. Сделайте шаг к здоровью уже сегодня. Рекомендована консультация специалиста Школы отказа по курению в ФГБУ «НМИЦ ТПМ».",
  "Курение в сочетании с высоким давлением и высоким уровнем холестерина значительно повышает риск инсульта. Бросив курить, вы сможете улучшить свое состояние. Рекомендована консультация специалиста Школы отказа по курению в ФГБУ «НМИЦ ТПМ».",
  "У курильщиков кровь становится гуще, повышая вероятность образования тромбов. Отказ от сигарет снижает этот риск и улучшает циркуляцию крови. Рекомендована консультация специалиста Школы отказа по курению в ФГБУ «НМИЦ ТПМ».",
  "Каждый день без сигарет улучшает работу сердечно-сосудистой системы. Начните процесс восстановления уже сейчас. Рекомендована консультация специалиста Школы отказа по курению в ФГБУ «НМИЦ ТПМ».",
  "Курение негативно сказывается на работе сердца даже у молодых людей. Чем раньше вы бросите, тем больше преимуществ получите. Рекомендована консультация специалиста Школы отказа по курению в ФГБУ «НМИЦ ТПМ».",
  "Если вы курите, ваш организм испытывает постоянное кислородное голодание. Отказ от табака улучшит насыщение крови кислородом и повысит выносливость. Рекомендована консультация специалиста Школы отказа по курению в ФГБУ «НМИЦ ТПМ».",
  "Курение снижает эффективность лечения гипертонии и сердечно-сосудистых заболеваний. Отказавшись от сигарет, вы увеличите шансы на успешное лечение. Рекомендована консультация специалиста Школы отказа по курению в ФГБУ «НМИЦ ТПМ».",
  "Чем дольше человек курит, тем выше риск внезапной сердечной смерти. Снизить этот риск можно, полностью отказавшись от табака. Рекомендована консультация специалиста Школы отказа по курению в ФГБУ «НМИЦ ТПМ».",
  "Никотин стимулирует выброс адреналина, повышая артериальное давление. Бросив курить, вы нормализуете работу сердца. Рекомендована консультация специалиста Школы отказа по курению в ФГБУ «НМИЦ ТПМ».",
  "Курение увеличивает нагрузку на сосуды, ускоряя их старение. Отказ от сигарет позволяет сосудам частично восстановиться. Рекомендована консультация специалиста Школы отказа по курению в ФГБУ «НМИЦ ТПМ».",
  "После отказа от курения риск инфаркта снижается уже через 24 часа, а через год сокращается в два раза. Сделайте первый шаг прямо сейчас. Рекомендована консультация специалиста Школы отказа по курению в ФГБУ «НМИЦ ТПМ».",
  "Табачный дым содержит угарный газ, который ухудшает транспорт кислорода в организме. Отказ от курения улучшает самочувствие и работоспособность. Рекомендована консультация специалиста Школы отказа по курению в ФГБУ «НМИЦ ТПМ».",
  "Курение повышает риск образования аневризм сосудов. Избавьтесь от этого риска, отказавшись от табака. Рекомендована консультация специалиста Школы отказа по курению в ФГБУ «НМИЦ ТПМ».",
  "Табачный дым разрушает эндотелий сосудов, провоцируя воспалительные процессы. Отказ от курения — ваш путь к восстановлению сосудистой системы. Рекомендована консультация специалиста Школы отказа по курению в ФГБУ «НМИЦ ТПМ».",
  "Бросив курить, вы снижаете нагрузку на сердце и улучшаете кровообращение. Уже через несколько недель самочувствие заметно улучшится. Рекомендована консультация специалиста Школы отказа по курению в ФГБУ «НМИЦ ТПМ».",
  "Каждая выкуренная сигарета увеличивает риск сердечного приступа. Чем меньше сигарет, тем ниже риск. Рекомендована консультация специалиста Школы отказа по курению в ФГБУ «НМИЦ ТПМ».",
  "Курение ускоряет развитие диабета и его осложнений. Отказ от табака улучшает контроль уровня сахара в крови. Рекомендована консультация специалиста Школы отказа по курению в ФГБУ «НМИЦ ТПМ».",
  "Курение ослабляет стенки сосудов, делая их хрупкими. Отказ от табака позволит сохранить их прочность и эластичность. Рекомендована консультация специалиста Школы отказа по курению в ФГБУ «НМИЦ ТПМ».",
  "Курение способствует образованию тромбов, увеличивая риск инсульта. Отказ от сигарет поможет снизить вероятность сосудистых катастроф. Рекомендована консультация специалиста Школы отказа по курению в ФГБУ «НМИЦ ТПМ».",
  "Отказ от курения — единственный способ остановить негативное воздействие табака на сосуды. Чем раньше вы бросите, тем быстрее организм начнет восстанавливаться. Рекомендована консультация специалиста Школы отказа по курению в ФГБУ «НМИЦ ТПМ».",
  "После отказа от курения уже через 2–3 недели улучшается циркуляция крови, а через месяц снижается одышка и улучшается работа сердца. Начните этот процесс сегодня. Рекомендована консультация специалиста Школы отказа по курению в ФГБУ «НМИЦ ТПМ».",
  "Курение влияет на свертываемость крови, увеличивая риск тромбообразования. Отказ от табака снижает этот риск и способствует нормализации кровотока. Рекомендована консультация специалиста Школы отказа по курению в ФГБУ «НМИЦ ТПМ».",
  "Бросить курить — значит дать своему сердцу шанс работать без перегрузки. Чем быстрее вы избавитесь от никотина, тем дольше сохраните здоровье. Рекомендована консультация специалиста Школы отказа по курению в ФГБУ «НМИЦ ТПМ».",
];

const nonSmokingMessages = [
  "Вы не курите, и это значит, что ваш риск развития сердечно-сосудистых заболеваний значительно ниже, чем у курильщиков. Однако, важно помнить и о других факторах риска, таких как неправильное питание, недостаток физической активности и стресс. Продолжайте вести здоровый образ жизни, следите за своим питанием и занимайтесь спортом, чтобы поддерживать свое сердце и сосуды в отличной форме.",
  "Не курите? Отлично! Теперь сделайте следующий шаг: сбалансируйте рацион, добавьте физическую активность и контролируйте уровень стресса.",
  "Вы не курите, а значит, ваши сосуды дольше остаются эластичными. Укрепите их еще больше: ешьте меньше соли и больше овощей.",
  "Вы не курите, а значит, помогаете сердцу работать без лишнего напряжения. Добавьте регулярные разминки, если ведете сидячий образ жизни.",
  "Вы не курите, а значит ваш риск инфаркта значительно ниже. Помните о том, что необходимо своевременно проходить профилактические осмотры и заботиться о своем сердце.",
  "Вы не курите — и это одно из лучших решений для вашего здоровья. Чтобы усилить эффект, добавьте больше движения в повседневную жизнь.",
  "Вы свободны от табакокурения, а значит, ваши сосуды в лучшей форме, чем у курильщиков. Поддерживайте этот баланс правильным питанием и активностью.",
  "Вы не курите, а значит, ваш риск развития сердечно-сосудистых заболеваний значительно ниже, чем у курильщиков. Однако, важно помнить и о других факторах риска, таких как неправильное питание, недостаток физической активности и стресс. Продолжайте вести здоровый образ жизни, следите за своим питанием и занимайтесь спортом, чтобы поддерживать свое сердце и сосуды в отличной форме.",
  "Вы не курите, а значит, ваши легкие и сердце работают без лишней нагрузки. Поддержите их здоровье: больше свежего воздуха, движения и сбалансированного питания.",
  "Отсутствие никотина в организме — это уже мощный вклад в здоровье. Укрепите его дальше: следите за уровнем холестерина и регулярно занимайтесь спортом.",
  "Вы не курите, а значит, ваш организм лучше насыщается кислородом. Сделайте еще один шаг к здоровью — добавьте ежедневные прогулки на свежем воздухе.",
  "Без табака ваше сердце работает легче и эффективнее. Укрепите его еще больше: избегайте лишнего стресса и следите за сбалансированным питанием.",
  "Вы не курите, а значит, не подвергаете себя лишним рискам. Чтобы сохранить здоровье, уделите внимание физической активности и полноценному отдыху.",
  "Вы сделали правильный выбор в пользу здоровья. Теперь добавьте контроль за уровнем холестерина и регулярные профилактические обследования.",
  "Никогда не курили? Значит, ваши сосуды эластичнее, а кровь циркулирует свободно. Чтобы закрепить этот эффект, больше двигайтесь и меньше нервничайте.",
  "Без табака ваша дыхательная система работает на полную мощность. Поддержите её: занимайтесь спортом, избегайте стрессов и высыпайтесь.",
  "Вы не курите — и это ваш главный ресурс долголетия. Поддержите его: питайтесь сбалансированно, оставайтесь активными и следите за своим здоровьем.",
];

const bloodPressureMessages = [
  "Ваше артериальное давление в норме, и это хороший знак. Продолжайте поддерживать здоровье сердца сбалансированным питанием и физической активностью.",
  "Ваше давление в пределах нормы, но важно следить за уровнем стресса и избегать переедания соли, чтобы сохранить этот показатель стабильным.",
  "У вас нормальное артериальное давление, и чтобы оно оставалось таким, включите в рацион больше овощей, ограничьте соль и следите за весом.",
  "Давление в норме – это отличный показатель здоровья сердечно-сосудистой системы. Поддержите его регулярными физическими нагрузками и полноценным отдыхом.",
  "Ваше артериальное давление стабильно, но профилактика никогда не бывает лишней. Регулярные прогулки и здоровый сон помогут поддерживать сосуды в тонусе.",
  "Нормальное давление – это результат правильного образа жизни. Следите за питанием, избегайте стрессов и не забывайте о физических упражнениях.",
  "Ваше давление не выходит за пределы нормы, но важно поддерживать эту стабильность: минимум стресса, больше движения и полноценный сон.",
  "Давление в пределах нормы – это отличный показатель. Чтобы сохранить его, важно соблюдать баланс между работой и отдыхом.",
  "Ваши сосуды работают без перегрузки, и это хороший знак. Укрепите их дополнительными кардионагрузками и контролем массы тела.",
  "Нормальное давление – это основа здоровья. Поддержите его правильным питанием, достаточным количеством воды и умеренными физическими нагрузками.",
  "Ваше давление в норме, но помните, что профилактика важна в любом возрасте. Регулярно измеряйте артериальное давление и избегайте вредных привычек.",
  "Ваши показатели давления не вызывают тревоги, но для долгосрочного здоровья важно не злоупотреблять жирной пищей и следить за уровнем сахара в крови.",
  "Давление в норме – отличный показатель. Закрепите этот успех здоровым сном, умеренной физической активностью и минимизацией стресса.",
  "Ваше давление стабильное, а значит, ваше сердце работает в оптимальном режиме. Поддержите его, соблюдая питьевой режим и контролируя уровень холестерина.",
  "Давление в норме, но не забывайте о регулярных профилактических осмотрах, чтобы убедиться в здоровье сосудов и сердца.",
  "Отличные показатели давления – это ваш ресурс для долголетия. Следите за питанием, ограничивайте кофеин и сохраняйте активный образ жизни.",
  "Ваше давление в норме, но для его поддержания важно избегать малоподвижного образа жизни и контролировать уровень стресса.",
  "У вас нормальное давление, но не забывайте о профилактике: сбалансированное питание, контроль уровня соли и регулярная физическая активность помогут сохранить его стабильным.",
  "Давление в норме – это результат хорошего ухода за своим здоровьем. Поддерживайте его, избегая переутомления и лишнего веса.",
  "Ваше давление соответствует норме, но с возрастом важно следить за его динамикой, регулярно измеряя и анализируя изменения.",
  "Нормальное давление – это отличная база для здоровья. Поддержите его, минимизируя потребление соли и насыщенных жиров.",
  "Ваши сосуды работают в оптимальном режиме, а значит, сердце не испытывает лишней нагрузки. Продолжайте заботиться о своем здоровье.",
  "Давление в пределах нормы – это ваш плюс. Чтобы сохранить его, старайтесь поддерживать физическую активность хотя бы 30 минут в день.",
  "Ваше давление в норме, но важно помнить, что избыточный вес и малоподвижный образ жизни могут его повысить. Следите за образом жизни.",
  "У вас нормальные показатели давления, и чтобы они оставались такими, включите в рацион больше продуктов, богатых калием и магнием.",
  "Ваше давление стабильное – это показатель здоровья сосудов. Укрепите их, контролируя уровень стресса и добавляя в рацион больше зелени.",
  "Давление в норме, но важно помнить, что злоупотребление алкоголем и курение могут привести к его повышению.",
  "Ваше давление в норме, но не забывайте, что наследственные факторы также играют роль. Регулярно контролируйте его, особенно после 40 лет.",
  "Давление в пределах нормы – это отличный показатель, но для его стабильности важно сохранять здоровый образ жизни и избегать ночных перекусов.",
  "Ваше давление в норме, но регулярные профилактические обследования помогут вовремя выявить возможные изменения в работе сердца и сосудов.",
];

// Функция для определения уровня сердечно-сосудистого риска на основе расчетного значения и возраста
const determineHeartRiskLevel = (riskValue: number, age: number): string => {
  let riskLevel = "low";

  if (age >= 40) {
    if (age < 50) {
      if (riskValue < 2.5) {
        riskLevel = "low";
      } else if (riskValue >= 2.5 && riskValue < 7.5) {
        riskLevel = "medium";
      } else if (riskValue >= 7.5) {
        riskLevel = "high";
      }
    } else if (age >= 50 && age < 70) {
      if (riskValue < 5) {
        riskLevel = "low";
      } else if (riskValue >= 5 && riskValue < 10) {
        riskLevel = "medium";
      } else if (riskValue >= 10) {
        riskLevel = "high";
      }
    } else if (age >= 70) {
      if (riskValue < 7.5) {
        riskLevel = "low";
      } else if (riskValue >= 7.5 && riskValue < 15) {
        riskLevel = "medium";
      } else if (riskValue >= 15) {
        riskLevel = "high";
      }
    }
  } else {
    riskLevel = "low";
  }

  return riskLevel;
};

// Функция для расчета сердечно-сосудистого риска
const calculateHeartRisk = (data: SurveyData): string => {
  console.log(
    "Входные данные для расчета сердечно-сосудистого риска:",
    JSON.stringify(data)
  );

  // Проверяем наличие всех необходимых данных
  const missingData = [];
  if (!data.age) missingData.push("возраст");
  if (!data.gender) missingData.push("пол");
  if (data.sb_pressure === undefined)
    missingData.push("систолическое давление");
  if (data.cholesterol === undefined) missingData.push("общий холестерин");

  // Если отсутствуют необходимые данные, возвращаем неизвестный риск с описанием
  if (missingData.length > 0) {
    const missingDataStr = missingData.join(", ");
    console.warn(
      `Отсутствуют необходимые данные для расчета сердечно-сосудистого риска: ${missingDataStr}`
    );

    return JSON.stringify({
      risk: "unknown",
      description:
        "Недостаточно данных для оценки сердечно-сосудистого риска. Для расчета необходимы данные о возрасте, поле, артериальном давлении и уровне холестерина. Отсутствующие данные: " +
        missingDataStr +
        ". Переданные данные: возраст - " +
        (data.age || "нет данных") +
        ", пол - " +
        (data.gender || "нет данных") +
        ", систолическое давление - " +
        (data.sb_pressure !== undefined ? data.sb_pressure : "нет данных") +
        ", холестерин - " +
        (data.cholesterol || "нет данных") +
        ".",
    });
  }

  // Упрощенный расчет риска SCORE2
  // В реальном приложении здесь должна быть полная реализация алгоритма SCORE2
  // Это приблизительная реализация для демонстрации
  let riskValue = 0;

  // Базовый риск зависит от возраста
  const age = data.age || 0; // Используем 0 если возраст undefined
  if (age < 50) {
    riskValue = 1;
  } else if (age >= 50 && age < 60) {
    riskValue = 3;
  } else if (age >= 60 && age < 70) {
    riskValue = 6;
  } else {
    riskValue = 10;
  }

  // Увеличиваем риск для мужчин
  if (data.gender === "male") {
    riskValue *= 1.5;
  }

  // Увеличиваем риск для курящих
  if (data.smoke) {
    riskValue *= 1.5;
  }

  // Увеличиваем риск при высоком давлении
  const sbPressure = data.sb_pressure || 0; // Используем 0 если давление undefined
  if (sbPressure > 140) {
    riskValue *= 1.3;
  } else if (sbPressure > 160) {
    riskValue *= 1.6;
  }

  // Учитываем уровень холестерина
  if (data.cholesterol !== undefined && data.hdl !== undefined) {
    // Приводим к типу number, поскольку мы уже проверили на undefined
    const totalCholesterol = Number(data.cholesterol);
    const hdl = Number(data.hdl);

    const nonHDL = calculateNonHDL(totalCholesterol, hdl);
    if (nonHDL > 4.9) {
      riskValue *= 1.6;
    } else if (nonHDL > 3.8) {
      riskValue *= 1.2;
    }
  }

  // Увеличиваем риск при наличии диабета
  if (data.question_0) {
    riskValue *= 1.5;
  }

  // Определяем уровень риска
  const riskLevel = determineHeartRiskLevel(riskValue, age);

  // Текстовые описания для разных уровней риска
  let description = "";

  if (riskLevel === "low") {
    description =
      "У вас низкий риск сердечно-сосудистых заболеваний. Продолжайте вести здоровый образ жизни, регулярно проходить профилактические осмотры и следить за артериальным давлением.";
  } else if (riskLevel === "medium") {
    description =
      "У вас умеренный риск сердечно-сосудистых заболеваний. Рекомендуется контроль артериального давления, уровня холестерина и глюкозы крови. Обратите внимание на факторы риска, такие как курение, избыточный вес и малоподвижный образ жизни.";
  } else {
    description =
      "У вас высокий риск сердечно-сосудистых заболеваний. Настоятельно рекомендуется консультация кардиолога для разработки индивидуальной программы профилактики и лечения. Необходим регулярный контроль артериального давления, липидного профиля и других факторов риска.";
  }

  return JSON.stringify({
    risk: riskLevel,
    description: description,
    score: riskValue.toFixed(1), // Добавляем точное значение риска для отображения
  });
};

/**
 * Функция рассчитывает уровень не-ЛПВП холестерина (ХС-неЛВП)
 */
const calculateNonHDL = (totalCholesterol: number, hdl: number): number => {
  return totalCholesterol - hdl;
};

// Функция для расчета генетического риска на основе голландских критериев
const calculateGeneticRisk = (data: SurveyData): string => {
  let totalScore = 0;

  // 1. Наследственный анамнез
  // Раннее развитие ССЗ или уровень ХС ЛПНП выше 95-й процентили у родственника 1-й степени родства
  if (data.question_5) {
    totalScore += 1; // +1 балл
  }

  // Наличие сухожильных ксантом у родственника 1-й степени родства или уровень ХС ЛПНП выше 95-й процентили у детей младше 18 лет
  if (data.question_7 || data.question_8) {
    totalScore += 2; // +2 балла
  }

  // 2. Персональный анамнез
  // Раннее развитие сердечно-сосудистых заболеваний
  if (data.question_1) {
    totalScore += 2; // +2 балла
  }

  // Раннее развитие атеросклеротического поражения церебральных/периферических артерий
  if (data.question_2) {
    totalScore += 1; // +1 балл
  }

  // 3. Данные физикального обследования
  // Ксантомы сухожилий
  if (data.question_3) {
    totalScore += 6; // +6 баллов
  }

  // Липидная дуга роговицы до 45 лет
  if (data.question_4) {
    totalScore += 4; // +4 балла
  }

  // 5. Анализ ДНК
  // Функциональная мутация генов LDLR, APOB или PCSK9
  if (data.question_9) {
    totalScore += 8; // +8 баллов
  }

  // Определение уровня риска на основе суммы баллов
  if (totalScore <= 2) {
    return JSON.stringify({
      risk: "low",
      description:
        "Вероятность наличия семейной формы гиперхолестеринемии низкая. Однако, это не полностью исключает риск развития атеросклероза и сердечно-сосудистых осложнений. Важно регулярно проходить профилактические осмотры и вести здоровый образ жизни.",
    });
  } else if (totalScore >= 3 && totalScore <= 5) {
    return JSON.stringify({
      risk: "medium",
      description:
        "Вероятность наличия семейной формы гиперхолестеринемии средняя. Рекомендуется консультация липидолога и дополнительное обследование для уточнения диагноза. Важно контролировать уровень холестерина и соблюдать рекомендации по образу жизни.",
    });
  } else {
    return JSON.stringify({
      risk: "high",
      description:
        "Высокая вероятность наличия семейной формы гиперхолестеринемии. Настоятельно рекомендуется консультация липидолога и генетическое тестирование. Требуется тщательный контроль уровня липидов крови и, возможно, медикаментозная терапия.",
    });
  }
};

// Функция для расчета риска гипертензии на основе систолического и диастолического давления
const calculateHypertensionRisk = (
  sbPressure: number,
  dbPressure: number
): string => {
  let adrisk = 0;

  if (sbPressure && dbPressure) {
    if (sbPressure < 130 && dbPressure < 85) {
      adrisk = 1; // Низкий риск
    } else if (sbPressure >= 130 && sbPressure <= 139) {
      if (dbPressure >= 85 && dbPressure <= 89) {
        adrisk = 2; // Умеренный риск
      } else if (dbPressure >= 90) {
        adrisk = 3; // Высокий риск
      } else {
        adrisk = 2; // Умеренный риск
      }
    } else if (dbPressure >= 85 && dbPressure <= 89) {
      if (sbPressure >= 130 && sbPressure <= 139) {
        adrisk = 2; // Умеренный риск
      } else if (sbPressure >= 139) {
        adrisk = 3; // Высокий риск
      } else {
        adrisk = 2; // Умеренный риск
      }
    } else {
      adrisk = 3; // Высокий риск
    }
  } else {
    adrisk = 0; // Нет данных
  }

  // Возвращаем результат в формате JSON строки, аналогично smoke_risk
  if (adrisk === 0) {
    return JSON.stringify({
      risk: "unknown",
      description:
        "Недостаточно данных для оценки риска артериальной гипертензии",
    });
  } else if (adrisk === 1) {
    return JSON.stringify({
      risk: "low",
      description:
        bloodPressureMessages[
          Math.floor(Math.random() * bloodPressureMessages.length)
        ],
    });
  } else if (adrisk === 2) {
    return JSON.stringify({
      risk: "medium",
      description:
        "Умеренный риск артериальной гипертензии. Рекомендуется регулярный контроль артериального давления.",
    });
  } else {
    return JSON.stringify({
      risk: "high",
      description:
        "Высокий риск артериальной гипертензии. Рекомендуется консультация кардиолога.",
    });
  }
};

// Функция для получения последних данных липидного профиля из API
const fetchLipidDataFromAPI = async (): Promise<{
  total_cholesterol: number;
  hdl: number;
  ldl?: number;
  triglycerides?: number;
} | null> => {
  try {
    // Используем axios напрямую для простоты
    const response = await axios.get(
      "https://lipapi0.grace3.ru/lipids/get_lipids_cookie"
    );

    if (response.data && response.data.length > 0) {
      // Берем последнюю запись
      const latestRecord = response.data[response.data.length - 1];
      return {
        total_cholesterol: latestRecord.total_cholesterol,
        hdl: latestRecord.hdl,
        ldl: latestRecord.ldl,
        triglycerides: latestRecord.triglycerides,
      };
    }
  } catch (error) {
    console.error(
      "Ошибка при получении данных липидного профиля из API:",
      error
    );
  }
  return null;
};

/**
 * Интерфейс для результатов оценки липидного профиля
 */
interface LipidAssessment {
  lpnp_risk: number; // 0 - нет данных, 1 - норма, 3 - высокий
  lpvp_risk: number; // 0 - нет данных, 1 - норма, 3 - низкий
  tg_risk: number; // 0 - нет данных, 1 - норма, 3 - высокий
  overall_risk: string; // "low", "medium", "high"
  description: string;
}

/**
 * Функция для оценки липидного профиля на основе данных липидограммы и уровня сердечно-сосудистого риска
 * @param ldl - уровень ЛПНП
 * @param hdl - уровень ЛПВП
 * @param tg - уровень триглицеридов
 * @param gender - пол пациента ("male" или "female")
 * @param heartRiskLevel - уровень сердечно-сосудистого риска ("low", "medium", "high")
 * @returns Объект с оценкой липидного профиля
 */
export const assessLipidProfile = (
  ldl: number | undefined,
  hdl: number | undefined,
  tg: number | undefined,
  gender: string | undefined,
  heartRiskLevel: string
): LipidAssessment => {
  let lpnpRisk = 0;
  let lpvpRisk = 0;
  let tgRisk = 0;
  let overallRisk = "medium";
  let description = "";

  // Оценка ЛПНП в зависимости от уровня сердечно-сосудистого риска
  if (ldl !== undefined) {
    if (heartRiskLevel === "low") {
      lpnpRisk = ldl <= 3 ? 1 : 3;
    } else if (heartRiskLevel === "medium") {
      lpnpRisk = ldl < 2.6 ? 1 : 3;
    } else {
      // high
      lpnpRisk = ldl < 1.8 ? 1 : 3;
    }
  }

  // Оценка ЛПВП в зависимости от пола
  if (hdl !== undefined && hdl > 0) {
    if (gender === "female") {
      lpvpRisk = hdl < 1.2 ? 3 : 1;
    } else {
      // male или undefined
      lpvpRisk = hdl < 1 ? 3 : 1;
    }
  }

  // Оценка триглицеридов
  if (tg !== undefined) {
    tgRisk = tg < 1.7 ? 1 : 3;
  }

  // Определение общего риска и формирование описания
  const hasHighRisks =
    [lpnpRisk, lpvpRisk, tgRisk].filter((risk) => risk === 3).length > 0;
  const hasNoData =
    [lpnpRisk, lpvpRisk, tgRisk].filter((risk) => risk === 0).length === 3;

  if (hasNoData) {
    overallRisk = "unknown";
    description =
      "Недостаточно данных для оценки липидного профиля. Рекомендуется сдать анализ крови на липидограмму.";
  } else if (hasHighRisks) {
    overallRisk = "high";

    const highRiskFactors = [];
    if (lpnpRisk === 3) highRiskFactors.push("повышенный уровень ЛПНП");
    if (lpvpRisk === 3) highRiskFactors.push("сниженный уровень ЛПВП");
    if (tgRisk === 3) highRiskFactors.push("повышенный уровень триглицеридов");

    description = `Нарушения липидного обмена: ${highRiskFactors.join(", ")}. `;

    if (heartRiskLevel === "high") {
      description +=
        "В сочетании с высоким сердечно-сосудистым риском это значительно увеличивает вероятность развития атеросклероза и его осложнений. Необходима консультация врача-липидолога для разработки индивидуальной программы лечения и профилактики осложнений.";
    } else {
      description +=
        "Рекомендуется консультация врача для коррекции липидного профиля с помощью диеты и/или медикаментозной терапии.";
    }
  } else {
    overallRisk = "low";
    description =
      "Показатели липидного обмена в пределах целевых значений. Рекомендуется поддерживать здоровый образ жизни и регулярно контролировать липидный профиль.";
  }

  return {
    lpnp_risk: lpnpRisk,
    lpvp_risk: lpvpRisk,
    tg_risk: tgRisk,
    overall_risk: overallRisk,
    description: description,
  };
};

/**
 * Функция для получения JSON-строки с оценкой липидного профиля для отображения в интерфейсе
 */
export const getLipidRiskJSON = (
  ldl: number | undefined,
  hdl: number | undefined,
  tg: number | undefined,
  gender: string | undefined,
  heartRiskLevel: string
): string => {
  const assessment = assessLipidProfile(ldl, hdl, tg, gender, heartRiskLevel);

  return JSON.stringify({
    risk: assessment.overall_risk,
    description: assessment.description,
    lpnp: {
      risk:
        assessment.lpnp_risk === 0
          ? "unknown"
          : assessment.lpnp_risk === 1
          ? "low"
          : "high",
      value: ldl,
    },
    lpvp: {
      risk:
        assessment.lpvp_risk === 0
          ? "unknown"
          : assessment.lpvp_risk === 1
          ? "normal"
          : "low",
      value: hdl,
    },
    tg: {
      risk:
        assessment.tg_risk === 0
          ? "unknown"
          : assessment.tg_risk === 1
          ? "low"
          : "high",
      value: tg,
    },
  });
};

// Модифицируем функцию calculateRisksAsync для использования JSON-строки с оценкой липидного профиля
export const calculateRisksAsync = async (
  data: SurveyData
): Promise<RiskResult> => {
  // ... existing code ...

  // Получаем данные о липидном профиле из API, если они отсутствуют
  let ldl: number | undefined;
  let tg: number | undefined;

  try {
    // Пытаемся получить дополнительные данные о липидном профиле (ЛПНП, ТГ)
    const lipidDataString = localStorage.getItem("lipid_data");
    if (lipidDataString) {
      const lipidData = JSON.parse(lipidDataString);
      if (lipidData.ldl !== undefined) {
        ldl = lipidData.ldl;
      }
      if (lipidData.triglycerides !== undefined) {
        tg = lipidData.triglycerides;
      }
    }

    // Если данных нет в localStorage, пытаемся получить из API
    if (ldl === undefined || tg === undefined) {
      const lipidApiData = await fetchLipidDataFromAPI();
      if (lipidApiData && lipidApiData.ldl !== undefined) {
        ldl = lipidApiData.ldl;
      }
      if (lipidApiData && lipidApiData.triglycerides !== undefined) {
        tg = lipidApiData.triglycerides;
      }
    }
  } catch (error) {
    console.error(
      "Ошибка при получении дополнительных данных липидного профиля:",
      error
    );
  }

  // Рассчитываем сердечно-сосудистый риск
  const heartRisk = calculateHeartRisk(data);

  // Извлекаем уровень риска из JSON строки
  let heartRiskLevel = "medium";
  try {
    const heartRiskObj = JSON.parse(heartRisk);
    heartRiskLevel = heartRiskObj.risk || "medium";
  } catch (e) {
    console.error("Ошибка при парсинге уровня сердечно-сосудистого риска:", e);
  }

  // Получаем JSON-строку с оценкой липидного профиля
  const lipidRisk = getLipidRiskJSON(
    ldl,
    data.hdl,
    tg,
    data.gender,
    heartRiskLevel
  );

  const risks: RiskResult = {
    result_risk: "Умеренный риск сердечно-сосудистых заболеваний",
    heart_risk: heartRisk,
    hypertension_risk: calculateHypertensionRisk(
      data.sb_pressure,
      data.db_pressure
    ),
    lipid_risk: lipidRisk,
    genetic_risk: calculateGeneticRisk(data),
    smoke_risk: data.smoke
      ? JSON.stringify({
          risk: "high",
          description:
            smokingMessages[Math.floor(Math.random() * smokingMessages.length)],
        })
      : JSON.stringify({
          risk: "low",
          description:
            nonSmokingMessages[
              Math.floor(Math.random() * nonSmokingMessages.length)
            ],
        }),
  };

  // Переопределяем результаты при наличии определенных факторов риска
  if (data.question_1 || data.question_2) {
    risks.heart_risk = JSON.stringify({
      risk: "high",
      description:
        "Очень высокий риск сердечно-сосудистых заболеваний. Настоятельно рекомендуется консультация кардиолога для разработки индивидуальной программы лечения и профилактики осложнений.",
    });
  }

  // Если есть ксантомы или липидная дуга, переопределяем оценку липидного профиля
  if (data.question_3 || data.question_4) {
    // Создаем объект из текущей JSON-строки
    let lipidRiskObj;
    try {
      lipidRiskObj = JSON.parse(lipidRisk);
      // Обновляем описание и уровень риска
      lipidRiskObj.risk = "high";
      lipidRiskObj.description =
        "Выраженные нарушения липидного обмена, возможно наличие семейной гиперхолестеринемии. Необходима консультация врача-липидолога.";
      // Преобразуем обратно в JSON-строку
      risks.lipid_risk = JSON.stringify(lipidRiskObj);
    } catch (e) {
      console.error("Ошибка при обновлении оценки липидного профиля:", e);
      risks.lipid_risk = JSON.stringify({
        risk: "high",
        description:
          "Выраженные нарушения липидного обмена, возможно наличие семейной гиперхолестеринемии. Необходима консультация врача-липидолога.",
        lpnp: { risk: "high" },
        lpvp: { risk: "unknown" },
        tg: { risk: "unknown" },
      });
    }
  }

  return risks;
};

// Прежняя синхронная версия, теперь использует асинхронную под капотом
export const calculateRisks = (data: SurveyData): RiskResult => {
  // Создаем копию объекта данных для безопасной работы
  const dataCopy = { ...data };

  // Пытаемся получить данные из localStorage
  try {
    console.log("calculateRisks: Загружаем данные из localStorage");

    // Пол и возраст
    const userDataString = localStorage.getItem("user_data");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      if (!dataCopy.gender && userData.gender) {
        dataCopy.gender = userData.gender;
      }
      if (!dataCopy.age && (userData.age || userData.birth_date)) {
        if (userData.age) {
          dataCopy.age = userData.age;
        } else if (userData.birth_date) {
          const birthDate = new Date(userData.birth_date);
          const today = new Date();
          let age = today.getFullYear() - birthDate.getFullYear();
          const monthDiff = today.getMonth() - birthDate.getMonth();
          if (
            monthDiff < 0 ||
            (monthDiff === 0 && today.getDate() < birthDate.getDate())
          ) {
            age--;
          }
          dataCopy.age = age;
        }
      }
    }

    // Липидный профиль
    const lipidDataString = localStorage.getItem("lipid_data");
    if (lipidDataString) {
      const lipidData = JSON.parse(lipidDataString);
      if (!dataCopy.cholesterol && lipidData.total_cholesterol) {
        dataCopy.cholesterol = lipidData.total_cholesterol;
      }
      if (!dataCopy.hdl && lipidData.hdl) {
        dataCopy.hdl = lipidData.hdl;
      }
    }
  } catch (error) {
    console.error("Ошибка при загрузке данных из localStorage:", error);
  }

  // Запускаем асинхронную загрузку липидного профиля для следующего расчета,
  // но не дожидаемся результата
  if (!dataCopy.cholesterol || !dataCopy.hdl) {
    console.log("calculateRisks: Запуск фоновой загрузки липидного профиля");
    fetchLipidDataFromAPI()
      .then((lipidData) => {
        if (lipidData) {
          localStorage.setItem("lipid_data", JSON.stringify(lipidData));
          console.log(
            "Данные липидного профиля сохранены в localStorage для следующего расчета"
          );
        }
      })
      .catch((error) => {
        console.error("Ошибка при фоновой загрузке липидного профиля:", error);
      });
  }

  // Рассчитываем риски с тем, что у нас уже есть
  console.log(
    "calculateRisks: Рассчитываем риски с доступными данными:",
    JSON.stringify(dataCopy)
  );

  // Получаем данные о липидном профиле
  let ldl: number | undefined;
  let tg: number | undefined;

  try {
    const lipidDataString = localStorage.getItem("lipid_data");
    if (lipidDataString) {
      const lipidData = JSON.parse(lipidDataString);
      if (lipidData.ldl !== undefined) {
        ldl = lipidData.ldl;
      }
      if (lipidData.triglycerides !== undefined) {
        tg = lipidData.triglycerides;
      }
    }
  } catch (error) {
    console.error(
      "Ошибка при получении данных липидного профиля из localStorage:",
      error
    );
  }

  // Рассчитываем сердечно-сосудистый риск
  const heartRisk = calculateHeartRisk(dataCopy);

  // Извлекаем уровень риска из JSON строки
  let heartRiskLevel = "medium";
  try {
    const heartRiskObj = JSON.parse(heartRisk);
    heartRiskLevel = heartRiskObj.risk || "medium";
  } catch (e) {
    console.error("Ошибка при парсинге уровня сердечно-сосудистого риска:", e);
  }

  // Получаем JSON-строку с оценкой липидного профиля
  const lipidRisk = getLipidRiskJSON(
    ldl,
    dataCopy.hdl,
    tg,
    dataCopy.gender,
    heartRiskLevel
  );

  const risks: RiskResult = {
    result_risk: "Умеренный риск сердечно-сосудистых заболеваний",
    heart_risk: heartRisk,
    hypertension_risk: calculateHypertensionRisk(
      dataCopy.sb_pressure,
      dataCopy.db_pressure
    ),
    lipid_risk: lipidRisk,
    genetic_risk: calculateGeneticRisk(dataCopy),
    smoke_risk: dataCopy.smoke
      ? JSON.stringify({
          risk: "high",
          description:
            smokingMessages[Math.floor(Math.random() * smokingMessages.length)],
        })
      : JSON.stringify({
          risk: "low",
          description:
            nonSmokingMessages[
              Math.floor(Math.random() * nonSmokingMessages.length)
            ],
        }),
  };

  if (dataCopy.question_1 || dataCopy.question_2) {
    risks.heart_risk = JSON.stringify({
      risk: "high",
      description:
        "Очень высокий риск сердечно-сосудистых заболеваний. Настоятельно рекомендуется консультация кардиолога для разработки индивидуальной программы лечения и профилактики осложнений.",
    });
  }

  // Если есть ксантомы или липидная дуга, переопределяем оценку липидного профиля
  if (dataCopy.question_3 || dataCopy.question_4) {
    // Создаем объект из текущей JSON-строки
    let lipidRiskObj;
    try {
      lipidRiskObj = JSON.parse(lipidRisk);
      // Обновляем описание и уровень риска
      lipidRiskObj.risk = "high";
      lipidRiskObj.description =
        "Выраженные нарушения липидного обмена, возможно наличие семейной гиперхолестеринемии. Необходима консультация врача-липидолога.";
      // Преобразуем обратно в JSON-строку
      risks.lipid_risk = JSON.stringify(lipidRiskObj);
    } catch (e) {
      console.error("Ошибка при обновлении оценки липидного профиля:", e);
      risks.lipid_risk = JSON.stringify({
        risk: "high",
        description:
          "Выраженные нарушения липидного обмена, возможно наличие семейной гиперхолестеринемии. Необходима консультация врача-липидолога.",
        lpnp: { risk: "high" },
        lpvp: { risk: "unknown" },
        tg: { risk: "unknown" },
      });
    }
  }

  return risks;
};

export type { SurveyData, RiskResult };
